import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
export default [{
  path: '/number/home/:activityId',
  name: ROUTE_NAME.NUMBER_HOME,
  meta: {
    title: '号码簿',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    needLogin: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "number" */
    '@/pages/number/home.vue');
  }
}, {
  path: '/number/select/:activityId',
  name: ROUTE_NAME.NUMBER_SELECT,
  meta: {
    title: '选择号码',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    needLogin: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "number" */
    '@/pages/number/select.vue');
  }
}, {
  path: '/number/suctom/:activityId',
  name: ROUTE_NAME.NUMBER_CUSTOM,
  meta: {
    title: '自定义号码',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    needLogin: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "number" */
    '@/pages/number/custom.vue');
  }
}];